export default __webpack_public_path__ + "static/media/flag.50364b68.svg";